var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Card',{staticClass:"mb-8 md:mb-12 bg-gray-200 text-gray-500"},[_c('p',{staticClass:"h4"},[_vm._v("There was a problem showing this record")]),(_vm.showError)?_c('p',[_c('code',{staticClass:"bg-gray-300 p-2"},[_vm._v(_vm._s(_vm.result))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }